import React, { Component } from "react";
import "./style.css";
import "../../../../../index.css";
class ToCollegeToolConditionSubject extends Component {
  render() {
    const { subjectCondition, handleChooseSubject } = this.props;
    return (
      <div className="toCollegeToolConditionSubject_box">
        <div className="toCollegeToolConditionSubject_img_box">
          <img
            alt=""
            src={require("../../../../../images/trinity/choose_subject.png")}
          ></img>
        </div>
        <div className="toCollegeToolConditionSubject_subject_box">
          <div onClick={() => handleChooseSubject("政")} className="fl">
            <img
              alt=""
              src={
                subjectCondition.includes("政")
                  ? require("../../../../../images/trinity/politics_choose.png")
                  : require("../../../../../images/trinity/politics.png")
              }
            ></img>
          </div>
          <div onClick={() => handleChooseSubject("史")} className="fl">
            <img
              alt=""
              src={
                subjectCondition.includes("史")
                  ? require("../../../../../images/trinity/history_choose.png")
                  : require("../../../../../images/trinity/history.png")
              }
            ></img>
          </div>
          <div onClick={() => handleChooseSubject("地")} className="fl">
            <img
              alt=""
              src={
                subjectCondition.includes("地")
                  ? require("../../../../../images/trinity/geography_choose.png")
                  : require("../../../../../images/trinity/geography.png")
              }
            ></img>
          </div>
          <div onClick={() => handleChooseSubject("物")} className="fl">
            <img
              alt=""
              src={
                subjectCondition.includes("物")
                  ? require("../../../../../images/trinity/physics_choose.png")
                  : require("../../../../../images/trinity/physics.png")
              }
            ></img>
          </div>
          <div onClick={() => handleChooseSubject("化")} className="fl">
            <img
              alt=""
              src={
                subjectCondition.includes("化")
                  ? require("../../../../../images/trinity/chemistry_choose.png")
                  : require("../../../../../images/trinity/chemistry.png")
              }
            ></img>
          </div>
          <div onClick={() => handleChooseSubject("生")} className="fl">
            <img
              alt=""
              src={
                subjectCondition.includes("生")
                  ? require("../../../../../images/trinity/biology_choose.png")
                  : require("../../../../../images/trinity/biology.png")
              }
            ></img>
          </div>
          <div onClick={() => handleChooseSubject("技")} className="fl">
            <img
              alt=""
              src={
                subjectCondition.includes("技")
                  ? require("../../../../../images/trinity/technology_choose.png")
                  : require("../../../../../images/trinity/technology.png")
              }
            ></img>
          </div>
        </div>
      </div>
    );
  }
}

export default ToCollegeToolConditionSubject;



// WEBPACK FOOTER //
// ./src/containers/ToCollegeTool/ToCollegeToolCondition/components/ToCollegeToolConditionSubject/index.js